var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTemplateSelectingStageIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15,
    fill: "#00B779"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1525_32543",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.04053,
    y: 7.04132,
    width: 16.9167,
    height: 16.9167,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1525_32543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7942 21.8434H10.565C10.1773 21.8434 9.84533 21.7055 9.56903 21.4296C9.29319 21.1533 9.15527 20.8213 9.15527 20.4337V10.5656C9.15527 10.1779 9.29319 9.84594 9.56903 9.56964C9.84533 9.2938 10.1773 9.15588 10.565 9.15588H14.7942V21.8434ZM13.3844 20.4337V10.5656H10.565V20.4337H13.3844ZM16.2039 14.7948V9.15588H20.4331C20.8207 9.15588 21.1527 9.2938 21.429 9.56964C21.7049 9.84594 21.8428 10.1779 21.8428 10.5656V14.7948H16.2039ZM17.6136 13.3851H20.4331V10.5656H17.6136V13.3851ZM16.2039 21.8434V16.2045H21.8428V20.4337C21.8428 20.8213 21.7049 21.1533 21.429 21.4296C21.1527 21.7055 20.8207 21.8434 20.4331 21.8434H16.2039ZM17.6136 20.4337H20.4331V17.6142H17.6136V20.4337Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTemplateSelectingStageIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TemplateSelectingStageIcon.d156f4db.svg";
export { ForwardRef as ReactComponent };